<script>
import dropdown from "@/components/form components/dropdown";
import { Datetime } from "vue-datetime";

export default {
  name: "trigger-auction-modal",
  components: {
    dropdown,
    Datetime,
  },
  data: function() {
    return {};
  },
  methods: {
    onModalClose: function() {
      this.$store.commit("toggleAuctionTriggerModal", false);
    },
    async triggerAuctionStart() {
      this.onModalClose();
      await this.$store.dispatch("getRequest", { controller: "auction", method: `startAuction/${this.activeAuction.id}` });
    },
  },
  computed: {
    modalVisible: function() {
      return this.$store.state.auctionTriggerShown;
    },
    activeAuction: function() {
      return this.$store.state.activeAuction;
    },
    activeBidders: function() {
      var result = this.$store.state.activeAuction.activeBidders ? Object.keys(this.$store.state.activeAuction.activeBidders).length : 0;
      return result;
    },
    presentVesselsCount: function() {
      if (this.$store.state.activeAuction.activeBidders) {
        var allBids = [];
        var activeBidders = this.$store.state.activeAuction.activeBidders;
        for (var i = 0; i < activeBidders.length; i++) {
          allBids.push(...activeBidders[i].associatedBids);
        }
        var uniqueBids = allBids.filter(function(item, pos) {
          return allBids.indexOf(item) == pos;
        });
        return uniqueBids.length;
      } else {
        return 0;
      }
    },
    totalVesselCount: function() {
      return this.activeAuction.bids.length;
    },
  },
  async mounted() {
    if (this.auctionId) {
      await this.getAuctionData();
    }
  },
};
</script>
<template>
  <div v-if="activeAuction">
    <b-modal :id="`start-auction-${activeAuction.id}-modal`" title="Start Auction" v-on:hidden="onModalClose" v-model="modalVisible">
      <div class="row">
        <div class="col-lg-12">
          <div v-if="!activeBidders">
            <span>There are currently no active bidders!</span>
            <br />
            <br />
          </div>
          <div v-else-if="totalVesselCount != presentVesselsCount">
            <span><span style="color:red">WARNING </span> - Only {{ presentVesselsCount }}/{{ totalVesselCount }} bids are currently represented.</span>
            <br />
            <br />
          </div>
          <span>Are you sure you want to start this auction early?</span>
        </div>
      </div>
      <template v-slot:modal-footer="{ cancel }">
        <div class="row" style="width:100%">
          <div class="col-6" style="padding-left:0px;">
            <b-button size="sm" variant="danger" block v-on:click="cancel()">
              Cancel
            </b-button>
          </div>
          <div class="col-6" style="padding-right:0px;">
            <b-button size="sm" variant="success" block v-on:click="triggerAuctionStart()">
              Start Auction Now
            </b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>
